<template>
  <div>
    <dialog-reset
      v-loading="loading"
      slotShow
      height="65vh"
      width="1150px"
      top="10vh"
      :title="title"
      :visible.sync="show"
    >
      <avue-form :option="optionForm" ref="form" v-model="ruleForm"></avue-form>
      <FormTable
        ref="formTable"
        :formData="formData"
        :optionConfig="optionConfig"
      />
      <span slot="dialog_footer" v-if="title != '查看详情'">
        <el-button
          icon="el-icon-circle-plus-outline"
          type="primary"
          @click="submitForm(20)"
          :disabled="loading"
          >提交</el-button
        >
        <el-button
          icon="el-icon-circle-close"
          @click="close"
          :disabled="loading"
          >取消</el-button
        >
      </span>
    </dialog-reset>
  </div>
</template>

<script>
import { add, update, getDetail } from "../api";
import FormTable from "@/basic-common/components/FormTable.vue";
export default {
  components: {
    FormTable,
  },
  data() {
    return {
      title: "",
      show: false,
      loading: false,
      ruleForm: {},
      formData: {
        list: [],
      },
      optionForm: {
        ...this.$store.state.formOption,
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: "货主",
            prop: "custName",
            type: "select",
            remote: true,
            dicUrl: "/api/produce/blade-dept/select/distinct/select",
            props: {
              label: "deptName",
              value: "id",
            },
          },
          {
            label: "车次编号",
            prop: "trainNumber",
          },
          {
            label: "车厢数",
            prop: "carriageCount",
            type: "number",
            min: 1,
            max: 99999,
          },
          {
            label: "总重量(吨)",
            prop: "totalWeight",
            type: "number",
            precision: 2,
            min: 0.01,
            max: 99999,
          },
          {
            label: "合同名称",
            prop: "contractName",
            type: "select",
            remote: true,
            dicUrl:
              "/api/produce/transport-contract/select/distinct/pycode?contractName={{key}}",
            props: {
              label: "contractName",
              value: "id",
            },
          },
          {
            label: "到达时间",
            prop: "trainArrivalTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
          },
          {
            label: "发车时间",
            prop: "trainDepartTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
          },
        ],
      },
      // 表格配置
      optionConfig: {
        columnType: "add", // 默认为add，会在open方法中动态设置
        column: [
          {
            label: "车厢号",
            prop: "carriageNo",
            type: "input",
            required: true,
          },
          {
            label: "物资名称",
            prop: "cargoName",
            type: "autocomplete-reset",
            typeUse: "cargoName",
            required: true,
          },
          {
            label: "数量(吨)",
            prop: "weight",
            type: "input",
            required: true,
          },
          {
            label: "称重方式",
            prop: "weightType",
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=weightType",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            required: true,
          },
          {
            label: "皮重(吨)",
            prop: "grossWeight",
            type: "input",
            required: true,
          },
          {
            label: "毛重(吨)",
            prop: "tareWeight",
            type: "input",
            required: true,
          },
          {
            label: "净重",
            prop: "netWeight",
            type: "input",
            required: true,
          },
        ],
      },
    };
  },
  methods: {
    //打开
    open(title, row) {
      this.show = true;
      this.title = title;
      this.ruleForm = {};
      this.formData = { list: [] };

      // 设置表单和表格的禁用状态
      this.optionForm.disabled = title == "查看详情";
      this.optionConfig.columnType =
        title == "查看详情" ? "view" : title == "修改" ? "edit" : "add";

      if (title == "查看详情" || title == "修改") {
        getDetail(row.id).then((res) => {
          this.ruleForm = res.data.data;
          this.formData = {
            ...res.data.data,
            list: res.data.data.list || [],
          };
          console.log(this.ruleForm);
        });
      }
    },
    //提交
    submitForm() {
      // _.debounce(() => {
      this.$refs.form.validate((valid, done) => {
        if (valid) {
          const submitData = {
            ...this.ruleForm,
            ...this.formData,
          };

          if (this.ruleForm.id) {
            update(submitData).then((res) => {
              console.log(res);
              this.close();
              done();
            });
          } else {
            add(submitData).then((res) => {
              console.log(res);
              this.close();
              done();
            });
          }
        }
      });
      // }, 1500)
    },
    //关闭
    close() {
      this.loading = false;
      this.show = false;
      this.$emit("getPageList");
    },
  },
};
</script>
<style scoped lang="scss"></style>
